import { Component, OnInit, ViewChild } from '@angular/core';
import { Utility, Guid } from 'src/app/core/common';
import { JobtitleService } from 'src/app/services/jobtitle.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { MatchingService } from 'src/app/services/matching.service';
import { NgxSmartModalComponent } from 'ngx-smart-modal';

class JobTitleItem {
  Id?: string;
  Title?: string;
  IsDisabled?: boolean;
  IsCompleted: boolean;
  UseForAlert: boolean;
  UseForTagging: boolean;
  RemoteJobType: string;
  UpdateDate?: Date;
  Variations?: string[];
  Experiences?: {
    Id?: string;
    Title?: string;
    IsRequired?: boolean;
    Variations?: string[];
  }[];
  Skills?: {
    Id?: string;
    Title?: string;
    IsRequired?: boolean;
    Variations?: string[];
  }[];
  Educations?: {
    Id?: string;
    Title?: string;
    IsRequired?: boolean;
    Variations?: string[];
  }[];
  Queries?: {
    Id?: string;
    Title?: string;
    IsRequired?: boolean;
    Variations?: string[];
  }[];
  Subscriptions?: {
    Id?: string;
    Title?: string;
    IsRequired?: boolean;
    Variations?: string[];
  }[];
}
@Component({
  templateUrl: './manage-jobtitles.component.html',
  styleUrls: ['./manage-jobtitles.component.scss']
})
export class ManageJobtitlesComponent implements OnInit {
  Object = Object;
  JSON = JSON;
  seekers: any[];
  seekersCount: number;
  jobs: any[];
  jobsCount: number;
  importList: string;
  private readonly minConnection = 3;
  suggestions: any;

  constructor(private jobtitleService: JobtitleService,
    public matchingService: MatchingService,
    private spinner: SpinnerService,
    private toast: ToastrService) { }

  criteria: any = {};
  jobTitles: JobTitleItem[] = [];

  selected: any;
  selectedLink: any;
  selectedField: string;
  seekerLocation?: any;
  jobLocation?: any;
  selectLink(field: string, link: any) {
    this.selectedField = field;
    this.selectedLink = Utility.clone(link);
    if (!this.selectedLink.Variations)
      this.selectedLink.Variations = [];
    delete this.selectedLink.IsRequired;
    delete this.selectedLink.Score;
  }

  fields = {
    'Experiences': 'سابقه شغلی',
    'Skills': 'مهارت‌ها',
    'Educations': 'رشته‌های‌تحصیلی',
    'Subscriptions': 'سابسکرایب‌ها',
    'Queries': 'جستجوها'
  };
  data: any;

  async ngOnInit() {
    await this.load();
  }

  private async load() {
    this.spinner.show('titles');
    if (!this.data)
      this.data = await this.jobtitleService.pureData(6000, this.minConnection, true);

    this.jobTitles = await this.jobtitleService.adminSearch(this.criteria);

    this.mergeData();

    this.spinner.hide('titles');
  }

  private mergeData() {
    const fields = ['Experiences', 'Skills', 'Educations', 'Subscriptions'];
    fields.forEach(f => {
      let values = (<any>this.jobTitles)
        .flatMap(jt => jt[f].map(s => s.Title).concat(jt[f].flatMap(sv => sv.Variations)))
        .filter(_ => !!_);

      this.data[f] = Utility.removeDuplicates(this.data[f].concat(values.filter(_ => !this.data[f].includes(_))));

      this.data[f + '_used'] = Utility.removeDuplicates(values);
    });
  }

  async add(titleInput: any) {
    this.toast.warning('در حال ذخیره');
    this.spinner.show('titles');
    await this.jobtitleService.save({ Title: titleInput.value });
    this.spinner.hide('titles');
    titleInput.value = '';
    this.toast.success('ذخیره شد');
    await this.load();
  }

  async save(selected: any, input: any = null, showtoast = true) {
    if (showtoast) this.toast.warning('در حال ذخیره');
    await this.jobtitleService.save(selected);
    if (showtoast) this.toast.success('ذخیره شد');
    if (input)
      input.value = '';
  }

  importSingle(selected: any, json: string) {
    let obj = JSON.parse(json);
    delete obj.Id;
    selected = Object.assign(selected, obj);
  }

  async delete(title: any) {
    this.toast.warning('در حال ذخیره');
    await this.jobtitleService.delete(title.Id);
    this.toast.success('ذخیره شد');
    await this.load();
  }

  async addLink(selected: any, field: string, key: string, showtoast = true) {
    var jobTitle = this.jobTitles.find(jt => jt[field].some((i: any) => i && (i.Title == key || i.Variations && i.Variations.includes(key))));
    var item: any = jobTitle
      ? jobTitle[field].find((i: any) => i && (i.Title == key || i.Variations && i.Variations.includes(key)))
      : { Id: Guid.newGuid(), Title: key, Variations: [] };
    selected[field].push({ Id: item.Id, Title: item.Title, Score: 1, Variations: item.Variations });
    await this.save(selected, undefined, showtoast);
  }
  async removeLink(selected: any, field: string, linkId: string) {
    var usage = this.linkUsage(field, linkId);
    if (usage.length == 1) {
      if (!confirm('این مورد فقط در همین عوان شغلی تعریف شده. با حذف آن همه جایگزین ها و اطلاعات مربوط به آن حذف خواهد شد. آیا مطمئن هستید؟'))
        return;
    }
    var index = selected[field].findIndex(_ => _.Id == linkId);
    if (index >= 0) {
      selected[field].splice(index, 1);
      await this.save(selected);
    }
  }
  async setVariation(field: string, link: any) {
    var jobTitles = this.linkUsage(field, link.Id);
    for (var jobTitle of jobTitles)
      jobTitle[field].find(_ => _.Id == link.Id).Variations = Utility.clone(link.Variations);
    await this.saveLink(field, link);
  }

  async saveLink(field: string, link: any) {
    this.toast.warning('در حال ذخیره');
    await this.jobtitleService.saveLink(field, link);
    this.toast.success('ذخیره شد');
    this.mergeData();
  }
  linkUsage(field: string, linkId: string) {
    return this.jobTitles.filter(jt => jt[field].find(_ => _.Id == linkId));
  }
  async deleteLink(field: string, link: any) {
    this.toast.warning('در حال ذخیره');
    var jobTitles = this.linkUsage(field, link.Id);
    for (var jobTitle of jobTitles) {
      let arr: any[] = jobTitle[field];
      arr.splice(arr.findIndex(_ => _.Id == link.Id), 1);
    }

    await this.jobtitleService.deleteLink(field, link.Id);
    this.toast.success('ذخیره شد');
  }

  usage(field: string, key: string, item?: any) {
    if (item != undefined) {
      if (item[field].some((i: any) => i && i.Title == key)) return 'اصلی';
      if (item[field].some((i: any) => i && i.Variations && i.Variations.includes(key))) return 'جایگزین';
    }
    else {
      if (this.jobTitles.some(jt => jt[field].some((i: any) => i && i.Title == key))) return 'اصلی';
      if (this.jobTitles.some(jt => jt[field].some((i: any) => i && i.Variations && i.Variations.includes(key)))) return 'جایگزین';
    }
    return '';
  }

  search: string;
  searchAll = false;
  completed?: boolean;
  useForAlert?: boolean;
  useForTagging?: boolean;
  isRemote?: boolean;
  get filteredJobTitles() {
    return ((!this.search && this.completed === undefined && this.useForAlert === undefined && this.useForTagging === undefined && this.isRemote === undefined) ? this.jobTitles :
      this.jobTitles.filter(_ =>
        (this.completed === undefined ? true : (_.IsCompleted === this.completed)) &&
        (this.useForAlert === undefined ? true : (_.UseForAlert === this.useForAlert)) &&
        (this.useForTagging === undefined ? true : (_.UseForTagging === this.useForTagging)) &&
        (this.isRemote === undefined ? true : (!_.RemoteJobType !== this.isRemote)) &&
        (
          !this.search ? true : this.searchKeyword(_)
        )
      )).sort((a: any, b: any) => b.SeekerStats?.TaggedCount - a.SeekerStats?.TaggedCount);
  }

  compareLink = (a: any, b: any) => b.Score - a.Score;

  private searchKeyword(item: JobTitleItem): unknown {
    return (
      (item.Title && item.Title.includes(this.search)) ||
      (this.searchAll && (
        (item.Variations && item.Variations.some(v => v && v.includes(this.search))) ||
        (item.Experiences && item.Experiences.some(s => (s.Title && s.Title.includes(this.search)) ||
          (s.Variations && s.Variations.some(v => v && v.includes(this.search)))
        )) ||
        (item.Skills && item.Skills.some(s => (s.Title && s.Title.includes(this.search)) ||
          (s.Variations && s.Variations.some(v => v && v.includes(this.search)))
        )) ||
        (item.Educations && item.Educations.some(e => (e.Title && e.Title.includes(this.search)) ||
          (e.Variations && e.Variations.some(v => v && v.includes(this.search)))
        )) ||
        (item.Queries && item.Queries.some(e => (e.Title && e.Title.includes(this.search)) ||
          (e.Variations && e.Variations.some(v => v && v.includes(this.search)))
        )) ||
        (item.Subscriptions && item.Subscriptions.some(e => (e.Title && e.Title.includes(this.search)) ||
          (e.Variations && e.Variations.some(v => v && v.includes(this.search)))
        ))
      ))
    );
  }

  async copy(item: any) {
    this.toast.warning('در حال ذخیره');
    var newItem = Utility.clone(item);
    delete newItem.Id;
    do {
      newItem.Title += ' - کپی';
    } while (this.jobTitles.find(_ => _.Title == newItem.Title));
    await this.jobtitleService.save(newItem);
    this.toast.success('ذخیره شد');
    await this.load();
  }

  async searchSeekers(jobTitle: any, order = "desc", limit = 500) {
    this.spinner.show('seekers');
    this.seekers = [];
    this.seekersCount = 0;
    let result = await this.jobtitleService.getSampleSeekers(jobTitle.Id, 0, limit, order, this.seekerLocation);
    this.seekers = result.users;
    this.seekersCount = result.total;
    this.spinner.hide('seekers');
  }
  async taggedSeekers(jobTitle: any, order = 'desc', limit = 500) {
    this.spinner.show('seekers');
    this.seekers = [];
    this.seekersCount = 0;
    let result = await this.jobtitleService.getTaggedSeekers(jobTitle.Id, 0, limit, order, this.seekerLocation);
    this.seekers = result.users;
    this.seekersCount = result.total;
    this.spinner.hide('seekers');
  }
  async searchJobs(jobTitle: any, order = 'desc', limit = 500, debug = false) {
    this.spinner.show('jobs');
    this.jobs = [];
    this.jobsCount = 0;
    let result = await this.jobtitleService.getSampleJobs(jobTitle.Id, 0, limit, order, this.jobLocation, debug);
    this.jobs = result.jobs;
    this.jobsCount = result.total;
    this.spinner.hide('jobs');
  }
  async taggedJobs(jobTitle: any, order = 'desc', limit = 500) {
    this.spinner.show('jobs');
    this.jobs = [];
    this.jobsCount = 0;
    let result = await this.jobtitleService.getTaggedJobs(jobTitle.Id, 0, limit, order, this.jobLocation);
    this.jobs = result.jobs;
    this.jobsCount = result.total;
    this.spinner.hide('jobs');
  }

  modifyField = 'Skills';
  // justUnused = true;
  // searchUnused: string;
  modifyItems: string[] = [];
  modifyTo: string[];
  onlyVerified = false;
  modifyJobTitles: any[];

  // get unusedItems() {
  //   if (!this.data || !this.data[this.modifyField]) return null;
  //   return (!this.justUnused ? this.data[this.modifyField] :
  //     this.data[this.modifyField].filter((_: string) => !this.usage(this.modifyField, _)))
  //     .filter(_ => !this.searchUnused || _.includes(this.searchUnused));
  // }

  @ViewChild('modifyModal') modifyModal: NgxSmartModalComponent;
  @ViewChild('importModal') importModal: NgxSmartModalComponent;
  private async _sendModify(...modifyTo: string[]) {

    this.spinner.show('modify');

    const progressToast = this.toast.warning('در حال ذخیره . . .', '0%', { disableTimeOut: true });
    var progress = 0;
    var translated = 0;
    for (var modify of this.modifyItems) {
      let total = await this.jobtitleService.translate(this.modifyField, modify, ...modifyTo);
      translated += +total;
      progressToast.toastRef.componentInstance.title = `${Math.round(++progress * 100 / this.modifyItems.length)}%`;
      progressToast.toastRef.componentInstance.message = `در حال ذخیره (${translated})`;
    }
    this.toast.clear(progressToast.toastId);
    this.data = await this.jobtitleService.pureData(6000, this.minConnection, true);
    this.mergeData();

    this.resetModifies();
    this.toast.success('ذخیره شد');
    this.spinner.hide('modify');
  }
  async sendModify() { await this._sendModify(...this.modifyTo); }
  async deleteModify() { await this._sendModify(); }

  async modifySuggestion(modifyField: string, item: any, modifyTo: string[]) {
    let total = await this.jobtitleService.translate(modifyField, item.Key, ...modifyTo);
    this.toast.success('ذخیره شد');
    this.resetModifies();
    item._edit = false;
    item._modified = modifyTo;
  }

  // openModify(key?: string) {
  //   if (key != undefined) this.modifyItems = [key];
  //   if (this.modifyItems.length == 1)
  //     this.modifyJobTitles = this.jobTitles.filter(jt => jt[this.modifyField].some(_ => _.Title == this.modifyItems[0]))
  //   this.modifyModal.open();
  // }
  checkJobTitles() {
    this.modifyJobTitles = this.modifyItems.length != 1 ? undefined :
      this.jobTitles.filter(jt => jt[this.modifyField].some(_ => _.Title == this.modifyItems[0]))
  }

  async addToJobTitle() {
    if (this.modifyItems.length != 1) return;

    this.spinner.show('modify');
    const progressToast = this.toast.warning('در حال ذخیره . . .', '0%', { disableTimeOut: true });
    var progress = 0;

    var link: any;
    var linkJT: any = this.jobTitles.find(jt => jt[this.modifyField].some(_ => _.Title == this.modifyItems[0]));
    if (linkJT)
      link = linkJT[this.modifyField].find(_ => _.Title == this.modifyItems[0]);

    if (link)
      for (var _jobtitle of this.jobTitles.filter(jt =>
        !this.modifyJobTitles.some(_ => _.Id == jt.Id) &&
        jt[this.modifyField].find(_ => _.Id == link.Id)))
        await this.removeLink(_jobtitle, this.modifyField, link.Id);

    var list = this.modifyJobTitles.filter(jt => !jt[this.modifyField].some(_ => _.Title == this.modifyItems[0]));
    for (var jobtitle of list) {
      await this.addLink(jobtitle, this.modifyField, this.modifyItems[0], false);
      progressToast.toastRef.componentInstance.title = `${Math.round(++progress * 100 / list.length)}%`;
    }
    this.toast.clear(progressToast.toastId);

    await this.load();
    this.resetModifies();
    this.toast.success('ذخیره شد');
    this.spinner.hide('modify');
  }

  toggleSelectModify(key: string) {
    var i = this.modifyItems.indexOf(key);
    if (i < 0) this.modifyItems.push(key);
    else this.modifyItems.splice(i, 1);
  }

  resetModifies() {
    this.modifyItems = [];
    delete this.modifyTo;
    delete this.modifyJobTitles;
    // this.modifyModal.close();
  }

  async import() {
    await this.jobtitleService.import(this.importList.split('\n'));
    this.importModal.close();
    await this.load();
  }

  async setStatistics(jobtitle: any) {
    this.spinner.show('statistics');
    let res = await this.jobtitleService.setStatistics(jobtitle.Id);
    jobtitle.SeekerStats = res.SeekerStats;
    jobtitle.JobStats = res.JobStats;
    this.spinner.hide('statistics');
  }
  async getSuggestions(jobtitle: any) {
    delete this.suggestions;
    this.suggestions = await this.jobtitleService.getSuggestions(jobtitle.Id);
  }
  async removeExistingSuggestions() {
    let temp = {};
    for (let p in this.suggestions)
      temp[p] = this.suggestions[p].filter(_ => !_.exists);
    this.suggestions = temp;
  }
  async removeJobTags(jobtitle: any) {
    let res = await this.jobtitleService.removeJobTags(jobtitle.Id);
    jobtitle.SeekerStats = res.SeekerStats;
    jobtitle.JobStats = res.JobStats;
  }
  async removeSeekerTags(jobtitle: any) {
    this.spinner.show('statistics');
    let res = await this.jobtitleService.removeSeekerTags(jobtitle.Id);
    jobtitle.SeekerStats = res.SeekerStats;
    jobtitle.JobStats = res.JobStats;
    this.spinner.hide('statistics');
  }
  async tagJobs(jobtitle: any) {
    this.spinner.show('statistics');
    let res = await this.jobtitleService.tagJobs(jobtitle.Id);
    jobtitle.SeekerStats = res.SeekerStats;
    jobtitle.JobStats = res.JobStats;
    this.spinner.hide('statistics');
  }
  async tagSeekers(jobtitle: any) {
    this.spinner.show('statistics');
    let res = await this.jobtitleService.tagSeekers(jobtitle.Id);
    jobtitle.SeekerStats = res.SeekerStats;
    jobtitle.JobStats = res.JobStats;
    this.spinner.hide('statistics');
  }
  async addSuggestions() {
    let positions = this.suggestions.position.filter(_ => _._add).map(_ => { return { Id: Guid.newGuid(), Title: _.Key, Score: 1 } });
    let skills = this.suggestions.skill.filter(_ => _._add).map(_ => { return { Id: Guid.newGuid(), Title: _.Key, Score: 1 } });
    let fields = this.suggestions.field.filter(_ => _._add).map(_ => { return { Id: Guid.newGuid(), Title: _.Key, Score: 1 } });;
    let subscribes = this.suggestions.subscribe.filter(_ => _._add).map(_ => { return { Id: Guid.newGuid(), Title: _.Key, Score: 1 } });;

    this.selected.Experiences = this.selected.Experiences.concat(positions);
    this.selected.Skills = this.selected.Skills.concat(skills);
    this.selected.Educations = this.selected.Educations.concat(fields);
    this.selected.Subscriptions = this.selected.Subscriptions.concat(subscribes);
  }

  variationSuggestions: string[];
  getVariationSuggestions(jobtitle: any) {
    var array = [jobtitle.Title, ...jobtitle.Variations, ...jobtitle.InformalVariations];
    var result = [];
    for (var item of array) {
      var parts = item.split(/\s|‌/g);
      if (parts.length < 2) continue;
      result.push(...this.addSpace(parts).filter(_ => !array.includes(_)));
    }
    this.variationSuggestions = result;
  }

  addSpace(array: string[]) {
    if (array.length == 1) return array;
    return Utility.flat([array[0] + array[1], array[0] + ' ' + array[1], array[0] + '‌' + array[1]]
      .map(f => this.addSpace([f, ...array.slice(2)])));
  }

  addVariationSuggestions() {
    this.selected.InformalVariations.push(...this.variationSuggestions);
    delete this.variationSuggestions;
  }
}
